export const gender = [
  {
    name: "Select",
    value: "",
  },
  {
    name: "Male",
    value: "Male",
  },
  {
    name: "Female",
    value: "Female",
  },
];
